/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AppointmentRequestVariantId } from './AppointmentRequestVariantId';
import {
    AppointmentRequestVariantIdFromJSON,
    AppointmentRequestVariantIdFromJSONTyped,
    AppointmentRequestVariantIdToJSON,
    AppointmentRequestVariantIdToJSONTyped,
} from './AppointmentRequestVariantId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface MakeupRequest
 */
export interface MakeupRequest {
    /**
     * 
     * @type {string}
     * @memberof MakeupRequest
     */
    attendanceLogId: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof MakeupRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupRequest
     */
    classId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupRequest
     */
    makeupClassId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof MakeupRequest
     */
    appointmentId: AppointmentRequestVariantId | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof MakeupRequest
     */
    makeupAppointmentId: AppointmentRequestVariantId | null;
    /**
     * 
     * @type {Date}
     * @memberof MakeupRequest
     */
    requestedDate: Date;
    /**
     * 
     * @type {string}
     * @memberof MakeupRequest
     */
    requestedStartTime: string;
    /**
     * 
     * @type {string}
     * @memberof MakeupRequest
     */
    requestedEndTime: string;
    /**
     * 
     * @type {string}
     * @memberof MakeupRequest
     */
    requestNote: string | null;
    /**
     * 
     * @type {Origin}
     * @memberof MakeupRequest
     */
    origin: Origin;
}



/**
 * Check if a given object implements the MakeupRequest interface.
 */
export function instanceOfMakeupRequest(value: object): value is MakeupRequest {
    if (!('attendanceLogId' in value) || value['attendanceLogId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('makeupClassId' in value) || value['makeupClassId'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('makeupAppointmentId' in value) || value['makeupAppointmentId'] === undefined) return false;
    if (!('requestedDate' in value) || value['requestedDate'] === undefined) return false;
    if (!('requestedStartTime' in value) || value['requestedStartTime'] === undefined) return false;
    if (!('requestedEndTime' in value) || value['requestedEndTime'] === undefined) return false;
    if (!('requestNote' in value) || value['requestNote'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function MakeupRequestFromJSON(json: any): MakeupRequest {
    return MakeupRequestFromJSONTyped(json, false);
}

export function MakeupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MakeupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'attendanceLogId': json['attendanceLogId'],
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'classId': ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'makeupClassId': ActorActivityRecordActorUserIdFromJSON(json['makeupClassId']),
        'appointmentId': AppointmentRequestVariantIdFromJSON(json['appointmentId']),
        'makeupAppointmentId': AppointmentRequestVariantIdFromJSON(json['makeupAppointmentId']),
        'requestedDate': (new Date(json['requestedDate'])),
        'requestedStartTime': json['requestedStartTime'],
        'requestedEndTime': json['requestedEndTime'],
        'requestNote': json['requestNote'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function MakeupRequestToJSON(json: any): MakeupRequest {
    return MakeupRequestToJSONTyped(json, false);
}

export function MakeupRequestToJSONTyped(value?: MakeupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attendanceLogId': value['attendanceLogId'],
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'makeupClassId': ActorActivityRecordActorUserIdToJSON(value['makeupClassId']),
        'appointmentId': AppointmentRequestVariantIdToJSON(value['appointmentId']),
        'makeupAppointmentId': AppointmentRequestVariantIdToJSON(value['makeupAppointmentId']),
        'requestedDate': value['requestedDate'].toISOString().substring(0,10),
        'requestedStartTime': value['requestedStartTime'],
        'requestedEndTime': value['requestedEndTime'],
        'requestNote': value['requestNote'],
        'origin': OriginToJSON(value['origin']),
    };
}

